// import type { AddressBook } from '@common/types/address-book.type';
import type { SitesCollectionState } from './sites.reducer';
import type { CollectionsState } from '../collections-feature.reducer';

import { createSelector } from '@ngrx/store';
import { SITES_COLLECTION_FEATURE_KEY, sitesAdapter } from './sites.reducer';
import { collectionsState } from '../collections-state.selectors';

const { selectCollection, selectCollectionStatus, selectCollectionStatuses } = sitesAdapter.getSelectors();

export const selectSitesState = createSelector(
    collectionsState,
    (state: CollectionsState): SitesCollectionState => state[SITES_COLLECTION_FEATURE_KEY]
);

export const selectSites = createSelector(selectSitesState, selectCollection);

export const selectSitesStatus = createSelector(selectSitesState, selectCollectionStatus);

export const selectSitesStatuses = createSelector(selectSitesState, selectCollectionStatuses);
